var map = {
	"./firon/firon.module.ngfactory": [
		"VT4V",
		2,
		0,
		6
	],
	"./ideaboard/ideaboard.module.ngfactory": [
		"fg59",
		2,
		0,
		7
	],
	"./report/report.module.ngfactory": [
		"ANN+",
		0,
		9
	],
	"./wiki/wiki.module.ngfactory": [
		"+gaE",
		2,
		0,
		8
	],
	"./workload/workload.module.ngfactory": [
		"O4Bf",
		0,
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;